import { FC } from "react";
import {
  AutocompleteOption,
  MiAbbreviationBadge,
} from "@miplatform/components";
import { IOrder } from "@miplatform/types";

export const OrderSearchOptionChip: FC<OrderSearchOptionChipProps> = ({
  option,
}) => {
  return (
    <MiAbbreviationBadge
      abbreviation={option.orderTemplateAbbreviation ?? "--"}
      backgroundColor={option.orderTemplateColor}
    />
  );
};

interface OrderSearchOptionChipProps {
  option: AutocompleteOption & IOrder;
}
